import { Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { CreateFitnessPlanComponent } from './fitness-plan/create-fitness-plan/create-fitness-plan.component';
import { FitnessPlanComponent } from './fitness-plan/fitness-plan.component';
import { UploadPlanComponent } from './fitness-plan/upload-plan/upload-plan.component';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { AuthGuard } from './guards/AuthGuard';
import { LoginComponent } from './login/login/login.component';
import { AllMealsComponentV2 } from './meal-plan-v2/all-meals/all-meals.component';
import { CreatePlanComponentV2 } from './meal-plan-v2/create-plan/create-plan.component';
import { ViewEditPlanComponent } from './meal-plan-v2/view-edit-plan/view-edit-plan.component';
import { TemplateViewComponent } from './meal-plan/meal-templates/template-view/template-view.component';
import { AllMealsComponent } from './meal-plan/all-meals/all-meals.component';
import { CreatePlanComponent } from './meal-plan/create-plan/create-plan.component';
import { MealDetailsComponent } from './meal-plan/meal-details/meal-details.component';
import { MealPlanComponent } from './meal-plan/meal-plan.component';
import { ResultMealPlanComponent } from './meal-plan/result-meal-plan/result-meal-plan.component';
import { SearchMealComponent } from './meal-plan/search-meal/search-meal.component';
import { ViewPlanComponent } from './meal-plan/view-meal-plan/view-plan.component';
import { MemberDashboardComponent } from './member-dashboard/member-dashboard.component';
import { EditFoodComponent } from './member-dashboard/life-style/nutrition/food-logging/edit-food/edit-food.component';
import { MemberDetailsComponent } from './member-details/member-details.component';
import { MemberListComponent } from './member/member-list/member-list.component';
import { AssignMemberListComponent } from './member/member-team-assign/assign-member-list.component';
import { ResetLinkComponent } from './reset-link/reset-link.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { TeamCreateComponent } from './team-create/team-create.component';
import { TeamEditComponent } from './team-edit/team-edit.component';
import { TeamListingComponent } from './team-listing/team-listing.component';

// Additional Fitness Template Routes
import { ExerciseInstructionsComponent } from './fitness-plan/exercise-instructions/exercise-instructions.component';
import { CreateTemplateComponent } from './fitness-plan/templates/create-template/create-template.component';
import { FitnessTemplatesComponent } from './fitness-plan/templates/fitness-templates.component';

// Recipes
import { AddRecipeComponent } from './recipe/add-recipe/add-recipe.component';
import { RecipesComponent } from './recipe/recipe-management/recipe-management.component';
import { UpdateRecipeComponent } from './recipe/update-recipe/update-recipe.component';
import { DataAnalysisComponent } from './data-analysis/data-analysis.component';
import { UserListComponent } from './user-list/user-list.component';
import { AddNewUserComponent } from './user-list/add-new-user/add-new-user.component';

import { AddEventComponent } from './event-calender/add-event/add-event.component';
// import { HealthToolsComponent } from './health-tools/health-tools.component';
import { QuestMindfulnessCreationComponent } from './quest-mindfulness-creation/quest-mindfulness-creation.component';

export const routes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard] },
  { path: 'forgot-password', component: ForgetPasswordComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'reset-password-link', component: ResetLinkComponent },

  { path: 'members', component: MemberListComponent, canActivate: [AuthGuard] },
  { path: 'user', component: UserListComponent, canActivate: [AuthGuard] },
  { path: 'user/add-new-user', component: AddNewUserComponent, canActivate: [AuthGuard] },
  { path: 'user/update-user/:userId', component: AddNewUserComponent, canActivate: [AuthGuard] },
  { path: 'member-details', component: MemberDetailsComponent, canActivate: [AuthGuard] },
  { path: 'member-dashboard', component: MemberDashboardComponent, canActivate: [AuthGuard] },
  { path: 'edit-food-log', component: EditFoodComponent, canActivate: [AuthGuard] },
  { path: 'members-assignment', component: AssignMemberListComponent, canActivate: [AuthGuard] },

  { path: 'teams', component: TeamListingComponent, canActivate: [AuthGuard] },
  { path: 'team-create', component: TeamCreateComponent, canActivate: [AuthGuard] },
  { path: 'team-edit', component: TeamEditComponent, canActivate: [AuthGuard] },

  // { path: 'health-tools', component: HealthToolsComponent, canActivate: [AuthGuard] },

  { path: 'meal-plans', component: MealPlanComponent, canActivate: [AuthGuard] },
  { path: 'create-plan', component: CreatePlanComponent, canActivate: [AuthGuard] },
  { path: 'meal-plan-result', component: ResultMealPlanComponent, canActivate: [AuthGuard] },
  { path: 'all-meal-plans', component: AllMealsComponent, canActivate: [AuthGuard] },
  { path: 'view-meal-plan', component: ViewPlanComponent, canActivate: [AuthGuard] },
  { path: 'search-result', component: SearchMealComponent, canActivate: [AuthGuard] },
  { path: 'meal-details', component: MealDetailsComponent, canActivate: [AuthGuard] },

  { path: 'v2/create-plan', component: CreatePlanComponentV2, canActivate: [AuthGuard] },
  { path: 'v2/all-meals', component: AllMealsComponentV2, canActivate: [AuthGuard] },
  { path: 'view-edit-plan', component: ViewEditPlanComponent, canActivate: [AuthGuard] },
  { path: 'template-view', component: TemplateViewComponent, canActivate: [AuthGuard] },

  { path: 'fitness-plan', component: FitnessPlanComponent, canActivate: [AuthGuard] },
  { path: 'create-fitness-plan', component: CreateFitnessPlanComponent, canActivate: [AuthGuard] },
  { path: 'upload-plan', component: UploadPlanComponent, canActivate: [AuthGuard] },

  { path: 'fitness-plan/templates', component: FitnessTemplatesComponent, canActivate: [AuthGuard] },
  { path: 'fitness-plan/templates/create', component: CreateTemplateComponent, canActivate: [AuthGuard] },
  { path: 'fitness-plan/templates/view/:id', component: CreateTemplateComponent, canActivate: [AuthGuard] },
  { path: 'fitness-plan/templates/edit/:id', component: CreateTemplateComponent, canActivate: [AuthGuard] },
  { path: 'fitness-plan/exercise-instructions', component: ExerciseInstructionsComponent, canActivate: [AuthGuard] },

  // Recipes
  { path: 'recipes', component: RecipesComponent, canActivate: [AuthGuard] },
  { path: 'add-recipe', component: AddRecipeComponent, canActivate: [AuthGuard] },
  { path: 'update-recipe/:id', component: UpdateRecipeComponent, canActivate: [AuthGuard] },

  { path: 'data-analysis', component: DataAnalysisComponent, canActivate: [AuthGuard] },

  { path: 'quest-mindfulness-creation', component: QuestMindfulnessCreationComponent, canActivate: [AuthGuard] },
  { path: 'event-calender/add-event', component: AddEventComponent },

  // Wildcard route - must be last
  { path: '**', redirectTo: '' }
];
